import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { environment } from '../../environments/environment';
import { IssueTrackerTemplateDTO, IssueTrackerTemplateIncidenceDTO } from '../models/issue-tracker-template-dto';

@Injectable({
  providedIn: 'root'
})

export class IssueTrackerTemplateService {

  private pathAPI = environment.urlAPI;
  private controller = 'IssueTrackerTemplate/';

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<IssueTrackerTemplateDTO> {
    return this.http.get<IssueTrackerTemplateDTO>(this.pathAPI + this.controller + id);
  }

  public getTemplatesByIncidence(idIncidence: string): Observable<IssueTrackerTemplateIncidenceDTO[]> {
    return this.http.get<IssueTrackerTemplateIncidenceDTO[]>(this.pathAPI + this.controller + 'GetTemplatesByIncidence/' + idIncidence);
  }

  public getTemplatesByProject(idProject: string): Observable<IssueTrackerTemplateIncidenceDTO[]> {
    return this.http.get<IssueTrackerTemplateIncidenceDTO[]>(this.pathAPI + this.controller + 'GetTemplatesByProject/' + idProject);
  }

  public post(data: IssueTrackerTemplateDTO): Observable<IssueTrackerTemplateDTO> {
    return this.http.post<IssueTrackerTemplateDTO>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: IssueTrackerTemplateDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any, filters: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + filters, data);
  }

}
